<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon>
        <v-icon @click="$router.go(-1)">mdi-backspace</v-icon>
      </v-btn>
      <v-toolbar-title>Gradebooks</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-select
        v-if="isStaff()"
        class="mt-6"
        v-model="section"
        :items="sections"
        item-text="name"
        item-value="id"
        label="Sections"
        return-object
        dark
        dense
      ></v-select>
    </v-toolbar>
    <v-toolbar v-if="section.name" color="secondary" class="mt-0" dense height="30">
      <v-toolbar-title>Tools: </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-card dense color="secondary lighten-1">
          <v-card-text>
            <v-row>
              <v-card
                v-for="gp in grading_periods"
                :key="gp.id"
                :dark="gp.id == grading_period.id"
                :color="gp.id == grading_period.id ? 'primary' : 'secondary lighten-1'"
                class="mx-2 px-1"
                dense
                @click="viewGradingPeriod(gp)"
                >{{ gp.name }}</v-card
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-toolbar-items>
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <k4-gradebook
          v-if="isStaff() && is_k4"
          :section_info="section"
          :grading_period="grading_period"
          :grading_periods="grading_periods"
        ></k4-gradebook>
        <gradebook
          v-if="isStaff() && !is_k4"
          :section_info="section"
          :grading_period="grading_period"
          :grading_periods="grading_periods"
        ></gradebook>
        <student-gradebook-all :student="{}" v-if="isStudent()"></student-gradebook-all>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import K4Gradebook from "../components/K4Gradebook";
import Gradebook from "../components/Gradebook";
import StudentGradebookAll from "../components/StudentGradebookAll";

export default {
  components: {
    K4Gradebook,
    Gradebook,
    StudentGradebookAll,
  },
  data: () => ({
    sections: [],
    section: {},
    grading_periods: [],
    grading_period: {},
  }),
  computed: {
    is_k4() {
      return this.section.is_k4;
    },
  },
  methods: {
    viewGradingPeriod(gp) {
      this.grading_period = gp;
    },
  },
  mounted() {
    this.$sisApi("get", "my-schedule/course-sections")
      .then((response) => {
        this.sections = response.data.map((item) => {
          item.name = `${item.course_name} Section ${item.section_name}`;
          return item;
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.$sisApi("get", "my-schedule/grading-periods")
      .then((response) => {
        this.grading_periods = response.data;
        this.grading_period = this.grading_periods.find(
          (gp) => new Date(gp.end_date) > new Date() // first match
        );
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
